<template>
  <div>
    <router-view></router-view>
    <Login />
    <FirstLogin />
  </div>
</template>

<script>
  import Login from '@/views/login/index2'
  import FirstLogin from '@/views/firstLogin/index'
  export default {
    name: 'layout',
    components: { Login, FirstLogin }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout.vue